import React from "react";

interface Option {
  value: string;
  label: string;
}

interface SelectProps {
  label?: string;
  name: string;
  value: string;
  options: Option[];
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

const Select: React.FC<SelectProps> = ({
  label,
  name,
  value,
  options,
  onChange,
  placeholder,
  className = "",
  disabled = false,
}) => (
  <div className="flex flex-col gap-y-2">
    {label && (
      <label className="text-sm text-gray-900 dark:text-gray-100 font-medium" htmlFor={name}>
        {label}
      </label>
    )}
    <select
      className={`border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 p-2 rounded-lg text-sm text-gray-900 dark:text-gray-100 font-normal focus:outline-none focus:border-blue-500 ${className}`}
      disabled={disabled}
      id={name}
      name={name}
      value={value}
      onChange={onChange}
    >
      {placeholder && (
        <option disabled value="">
          {placeholder}
        </option>
      )}
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);

export default Select;
